import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  BELÉPÉSI FIÓKOK.
 *
 *  A rendszer két külön nyilvántartásból áll: a törzsadatból (ki a gondviselő) és a
 *  belépési rendszerből (kinek van fiókja). A kettő csendben elcsúszhat: a gondviselő
 *  minden adata rendben van, mégsem tud belépni. Ez eddig sehol nem látszott – a
 *  hiányra akkor derült fény, amikor a szülő szólt.
 */
@Component({
  selector: 'app-admin-keycloak-fiokok',
  templateUrl: './keycloak-fiokok.component.html',
  styleUrls: ['./keycloak-fiokok.component.scss'],
})
export class AdminKeycloakFiokokComponent implements OnInit {
  toltodik = true;
  intezmeny = '';

  b: any = { alapcim: '', realm: 'master', kliens: 'admin-cli', felhasznalo: '', engedelyezve: true };
  jelszo = '';
  jelszoBeallitva = false;
  ment = false;
  tesztFut = false;
  eredmeny: { ok: boolean; szoveg: string } | null = null;
  beallitasNyitva = false;

  fajta: 'gondviselo' | 'dolgozo' | 'tanulo' = 'gondviselo';
  /*  Gondviselő és tanuló CSAK az iskolában (SULINFORM) van. A többi modulban a
   *  felhasználó munkatárs vagy ügyfél (mindkettő a dolgozói körben): ott csak az
   *  ő fiókjaik látszanak, a gondviselői részek elmaradnak. */
  mode = 'SULINFORM';
  get sulinform(): boolean { return this.mode === 'SULINFORM'; }
  ellenorzesFut = false;
  osszevetes: any = null;
  csakHianyzo = true;
  szuro = '';

  importFut = false;
  jelszavas = false;
  importEredmeny: any = null;

  /** Hány jelszót kell ténylegesen kiosztani (a születési dátumot a felhasználó tudja). */
  get kiosztandoJelszavak(): number {
    return (this.importEredmeny?.jelszavak || [])
      .filter((s: any) => s.forras !== 'szuletes').length;
  }

  /*  BEKÖTÉSEK – kinek a belépési neve melyik személyt jelenti.
   *
   *  A rendszer magától összeköti a kettőt, ha egyértelmű (jellemzően a gondviselőknél,
   *  akiknek a törzsadata az EGYIK gyerekük azonosítóján áll, a fiókjuk a MÁSIKÉN).
   *  Ami nem volt egyértelmű, az itt MUNKALISTA: ezek a fiókok be tudnak lépni, de a
   *  nyilvántartásban nincsenek meg – ezt embernek kell rendbe tennie. */
  bekotesek: any[] = [];
  bekotesFut = false;

  get bekotve(): any[] { return this.bekotesek.filter((b) => b.allapot === 'kotve'); }
  get bekotesHianyzo(): any[] { return this.bekotesek.filter((b) => b.allapot !== 'kotve'); }

  /*  E-MAIL NÉLKÜLI FIÓKOK. A pótlás tervét a szerver számolja, és végrehajtáskor újra
   *  kiszámolja – a bizonytalanok közül csak a kijelöltek mennek. */
  emailPotlas: any = null;
  emailPotlasFut = false;
  emailPotlasKijelolt = new Set<string>();
  emailPotlasEredmeny: any = null;

  private static readonly ALLAPOT_SORREND: Record<string, number> =
    { bizonytalan: 0, potolhato: 1, utkozes: 2, 'kozos-cim': 3, 'nincs-cim': 4 };

  get emailPotlasRendezett(): any[] {
    return [...(this.emailPotlas?.tetelek || [])].sort((a: any, b: any) =>
      (AdminKeycloakFiokokComponent.ALLAPOT_SORREND[a.allapot] ?? 9)
        - (AdminKeycloakFiokokComponent.ALLAPOT_SORREND[b.allapot] ?? 9)
      || String(a.uj_nev).localeCompare(String(b.uj_nev), 'hu'));
  }

  constructor(private http: HttpClient, private data: DataService) {}

  async emailPotlasBetolt() {
    if (this.emailPotlasFut) return;
    this.emailPotlasFut = true;
    this.emailPotlasEredmeny = null;
    try {
      this.emailPotlas = await firstValueFrom(this.http.get(
        `/api/admin/keycloak-fiokok/email-potlas/${this.intezmenyPath}?intezmeny=${encodeURIComponent(this.intezmeny)}&mode=${encodeURIComponent(this.mode)}`));
      this.emailPotlasKijelolt = new Set();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az ellenőrzés nem sikerült.', 'error');
    } finally {
      this.emailPotlasFut = false;
    }
  }

  emailPotlasJelol(t: any, be: boolean) {
    if (be) this.emailPotlasKijelolt.add(t.azonosito); else this.emailPotlasKijelolt.delete(t.azonosito);
  }

  async emailPotlasVegrehajt() {
    const db = (this.emailPotlas?.potolhato || 0) + this.emailPotlasKijelolt.size;
    if (!db || !confirm(`${db} belépési fiók kapja meg a törzsadatban rögzített e-mail címet és nevet.\n\n`
      + 'A jelszó nem változik, levél nem megy ki. Folytatod?')) return;
    this.emailPotlasFut = true;
    let eredmeny: any = null;
    try {
      eredmeny = await firstValueFrom(this.http.post(
        `/api/admin/keycloak-fiokok/email-potlas/${this.intezmenyPath}`,
        { intezmeny: this.intezmeny, bizonytalan: [...this.emailPotlasKijelolt], mode: this.mode }));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A pótlás nem sikerült.', 'error');
    } finally {
      this.emailPotlasFut = false;
    }
    await this.emailPotlasBetolt();
    this.emailPotlasEredmeny = eredmeny;
  }

  async ngOnInit() {
    const si = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    this.mode = String((await this.data.getFromStorage('currentMode')) || 'SULINFORM');
    if (!this.sulinform) this.fajta = 'dolgozo';
    await this.betolt();
    await this.bekotesekBetolt();
  }

  get intezmenyPath(): string { return encodeURI(this.intezmeny); }

  async betolt() {
    this.toltodik = true;
    try {
      const r: any = await firstValueFrom(this.http.get('/api/admin/keycloak-fiokok/beallitas'));
      this.b = {
        alapcim: r?.alapcim || '', realm: r?.realm || 'master',
        kliens: r?.kliens || 'admin-cli', felhasznalo: r?.felhasznalo || '',
        engedelyezve: r?.engedelyezve !== false,
      };
      this.jelszoBeallitva = !!r?.jelszo_beallitva;
      // Ha még nincs beállítva a hozzáférés, nyissuk ki: enélkül a képernyő
      // magyarázat nélkül nem csinálna semmit.
      this.beallitasNyitva = !this.b.alapcim || !this.jelszoBeallitva;
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A beállítás nem tölthető be.', 'error');
    } finally {
      this.toltodik = false;
    }
  }

  async mentes() {
    if (this.ment) return;
    this.ment = true;
    try {
      await firstValueFrom(this.http.put('/api/admin/keycloak-fiokok/beallitas',
        { ...this.b, jelszo: this.jelszo || undefined }));
      this.jelszo = '';
      this.data.sendToast('Mentve.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally {
      this.ment = false;
    }
  }

  async teszt() {
    if (this.tesztFut) return;
    this.tesztFut = true;
    this.eredmeny = null;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/admin/keycloak-fiokok/teszt', {}));
      this.eredmeny = r?.ok
        ? { ok: true, szoveg: `Kapcsolat rendben: ${r.alapcim} · „${r.realm}" · ${r.fiokok} fiók.` }
        : { ok: false, szoveg: r?.error || 'A kapcsolat nem sikerült.' };
    } catch (e: any) {
      this.eredmeny = { ok: false, szoveg: e?.error?.error || 'A kapcsolat nem sikerült.' };
    } finally {
      this.tesztFut = false;
    }
  }

  async ellenoriz() {
    if (this.ellenorzesFut) return;
    this.ellenorzesFut = true;
    this.osszevetes = null;
    this.importEredmeny = null;
    try {
      this.osszevetes = await firstValueFrom(this.http.get(
        `/api/admin/keycloak-fiokok/ellenorzes/${this.intezmenyPath}?fajta=${this.fajta}&mode=${encodeURIComponent(this.mode)}`));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az ellenőrzés nem sikerült.', 'error');
    } finally {
      this.ellenorzesFut = false;
    }
  }

  get szurtTetelek(): any[] {
    const lista = (this.osszevetes?.tetelek || [])
      .filter((t: any) => !this.csakHianyzo || !t.van);
    const k = this.szuro.trim().toLowerCase();
    if (!k) return lista;
    return lista.filter((t: any) =>
      String(t.teljes_nev || '').toLowerCase().includes(k)
      || String(t.azonosito || '').toLowerCase().includes(k)
      || String(t.email || '').toLowerCase().includes(k));
  }

  async importKeszit() {
    if (this.importFut) return;
    this.importFut = true;
    try {
      this.importEredmeny = await firstValueFrom(this.http.post(
        `/api/admin/keycloak-fiokok/import/${this.intezmenyPath}`,
        { fajta: this.fajta, jelszavas: this.jelszavas, mode: this.mode }));
      if (!this.importEredmeny?.hianyzik) {
        this.data.sendToast('Nincs hiányzó fiók – nincs mit importálni.', 'warning');
      }
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Az importfájl nem készült el.', 'error');
    } finally {
      this.importFut = false;
    }
  }

  letoltJson() {
    if (!this.importEredmeny) return;
    this.letolt(JSON.stringify(this.importEredmeny.keycloak, null, 2),
      this.importEredmeny.fajlnev, 'application/json');
  }

  /*  A jelszólista CSV-ben, mert ezt ki kell osztani – és a levelezőprogramba,
   *  körlevélbe táblázatként kell bemennie, nem JSON-ként. */
  letoltJelszavak() {
    const sorok = this.importEredmeny?.jelszavak || [];
    if (!sorok.length) return;
    const esc = (v: any) => `"${String(v ?? '').replace(/"/g, '""')}"`;
    /*  A JELSZÓ FORRÁSA IS BEKERÜL: a születési dátumot a felhasználó fejből tudja,
     *  azt nem kell kiosztani – a véletlen számsort viszont IGEN. E nélkül az oszlop
     *  nélkül az egész listát ki kellene küldeni, holott jellemzően csak pár sort. */
    const csv = ['Név;Belépési azonosító;E-mail;Ideiglenes jelszó;Jelszó forrása']
      .concat(sorok.map((s: any) => [s.nev, s.azonosito, s.email, s.jelszo,
        s.forras === 'szuletes' ? 'születési dátum (tudja)' : 'véletlen — ki kell adni']
        .map(esc).join(';')))
      .join('\r\n');
    // BOM, hogy az Excel az ékezeteket is jól nyissa meg.
    this.letolt('﻿' + csv,
      this.importEredmeny.fajlnev.replace(/\.json$/, '-jelszavak.csv'), 'text/csv');
  }

  async bekotesekBetolt() {
    this.bekotesFut = true;
    try {
      const r: any = await firstValueFrom(this.http.get(
        `/api/belepes-bekotes/lista?intezmeny=${encodeURIComponent(this.intezmeny)}&mode=${encodeURIComponent(this.mode)}`));
      this.bekotesek = Array.isArray(r) ? r : [];
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A bekötések nem tölthetők be.', 'error');
    } finally {
      this.bekotesFut = false;
    }
  }

  /*  VISSZAVONÁS. A bekötés nem ír át semmit, csak összeköt – a visszavonás tehát
   *  következmény nélkül való: a felhasználó a következő belépésnél megint ott lesz,
   *  ahol most, és a rendszer újra megpróbálja feloldani. */
  async bekotestVisszavon(b: any) {
    if (!confirm(`Visszavonod a bekötést?\n\n${b.username} → ${b.azonosito}\n\n`
      + 'A felhasználó ettől nem veszít adatot: a következő belépésnél a rendszer újra '
      + 'megpróbálja feloldani, ki ő.')) return;
    try {
      await firstValueFrom(this.http.delete(
        `/api/belepes-bekotes/${encodeURIComponent(b.username)}?intezmeny=${encodeURIComponent(this.intezmeny)}`));
      await this.bekotesekBetolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A visszavonás nem sikerült.', 'error');
    }
  }

  private letolt(tartalom: string, nev: string, tipus: string) {
    const blob = new Blob([tartalom], { type: `${tipus};charset=utf-8` });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = nev; a.click();
    URL.revokeObjectURL(url);
  }
}
